import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Inject preconnect/dns-prefetch hints to speed up font + image CDN handshakes on mobile.
// Adding from JS avoids needing to edit index.html.
function addPreconnect(href: string, crossOrigin?: boolean) {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  if (crossOrigin) link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
}
addPreconnect('https://fonts.googleapis.com');
addPreconnect('https://fonts.gstatic.com', true);
addPreconnect('https://cdn.magicpatterns.com', true);
render(<App data-id="element-557" />, document.getElementById('root'));